export const COLORS = {
  ALTO: '#E0E0E0',
  BLACK: '#000000',
  ELECTRIC_VIOLET: '#801DE7',
  JAGGED_ICE: '#c4e4ea',
  JET_STREAM: '#ADCFCC',
  LIGHT_INVALID: '#E24C4C',
  ON_OUTLINE_LIGHT: '#6F7977',
  ON_SURFACE: '#191C1B',
  ON_SURFACE_1: '#006A61',
  ON_SURFACE_2: '#006c51',
  ON_SURFACE_4: '#dcebe8',
  ON_SURFACE_VARIANT: '#3F4947',
  ON_TERTIARY_CONTAINER: '#001D32',
  BACKGROUND_ON_TERTIARY_CONTAINER: '#CDE5FF',
  BACKGROUND_ON_SECONDARY_CONTAINER: '#D9D9D9',
  PASTEL_E: '#DFEDEA',
  PASTEL_E_HOVER: '#CEE5E0',
  REJECT: '#C63737',
  RED_CINNABAR: '#E53935',
  SILVER_SAND: '#BDC1C3',
  CONTENT_LIGHT_TERTIARY: '#646867',
  BACKGROUND_PINK_LIGHT: '#FFF7FF',
  WHITE: '#FFFFFF',
  CONTENT_POSITIVE: '#006D3A',
  CONTENT_WARNING: '#A16709',
  BACKGROUND_LIGHT: '#F4F6F6',
  NEUTRAL_300: '#DDDDDD',
  BLUE_500: '#186AFF',
  LIGHT_ERROR: '#BA1A1A',
  AUTH_BACKGROUND: '#FBFDFC',
  TOAST_SUCCESS_COLOR: '#05201C',
  TOAST_SUCCESS_BACKGROUND: '#CCE8E3',
  TOAST_ERROR_COLOR: '#73000C',
  TOAST_ERROR_BACKGROUND: '#FFDAD6',
  TOAST_ERROR_BORDER: '#410002',
  TOAST_WARNING_COLOR: '#F57C00',
  TOAST_WARNING_BACKGROUND: '#FFF9C4',
  TOAST_WARNING_BORDER: '#FFEB3B',
  GRAY: '#191C1B1F',
  ON_SURFACE_LIGHT_2: '#EDF5F3',
  BACKGROUND_ERROR_PASTEL: '#FFF8F7',
  INFO_BLUE: '#0060AB',
  BACKGROUND_AVATAR_BLUE: '#D3E3FF',
  BACKGROUND_DEFAULT: '#DAE5E2',
  TAIL_BOT: '#EDEFEE',
} as const;
